import {Injectable} from '@angular/core';
import {BehaviorSubject, map, Observable, of, tap} from "rxjs";
import {Studente} from "../../api-clients/generated/services";
import {LocalStorageService} from "./local-storage.service";

@Injectable({
  providedIn: 'root'
})
export class GlobalManagerFigliService {
  checkCurrentStudente$ = new BehaviorSubject(this.getCurrentStudente());
  currentStudente: Studente | undefined;
  opzioniStudenti: Array<Studente> = [];
  StudenteTitle: string = '';
  isMultipleChildren: boolean = false;
  private static LS_KEY = 'LS_KEY';

  constructor(private localStorageService: LocalStorageService) {
  }
  init() {
    this.getFigli$().pipe(
      tap((figli: Array<Studente>) =>
        this.setCurrentStudente(figli[0])
      ),
    ).subscribe();
  }

  getCurrentStudente() {
    return this.currentStudente
  }

  setCurrentStudente(Studente: Studente | undefined) {
    this.currentStudente = Studente;
    this.checkCurrentStudente$.next(Studente)
    if (Studente?.id) {
      this.saveCurrentStudenteId(Studente.id);
    }
  }


  getFigli$(): Observable<Studente[]> {
    const anagrafiche = this.localStorageService.getAnagrafiche() ?? [];
    return of(anagrafiche).pipe(
      map((a) => {
        const tutti = a.flatMap(ana => ana.studenti ?? []) as Studente[];
        return Array.from(new Map(tutti.map(s => [s.id, s])).values());
      }),
      tap((studenti) => this.opzioniStudenti = studenti
        .slice()
        .sort((a, b) => {
          const nomeCompare = (a?.nome ?? '').localeCompare(b?.nome ?? '');
          if (nomeCompare !== 0) {
            return nomeCompare;
          }
          return (a?.cognome ?? '').localeCompare(b?.cognome ?? '');
        })
      ),
      tap((figli: Array<Studente>) => {
        if (figli.length === 0) {
          this.setCurrentStudente(undefined);
          this.removeSavedStudenteId();
          return;
        }
        const studenteLocal = this.checkCurrentStudenteLocalStorage(figli);
        if(!!studenteLocal) {
          const figlio = figli.find(s => s.id === studenteLocal.id)
          if(figlio){
            this.setCurrentStudente(figlio);
          }  else {
            this.removeSavedStudenteId();
            this.setCurrentStudente(figli[0]);
          }
        } else if (this.checkCurrentStudenteAfterRequest(figli)) {
          this.setCurrentStudente(figli.find(s => s.id === this.currentStudente!.id));
        } else {
          this.setCurrentStudente(figli[0]);
        }
        this.isMultipleChildren = figli.length > 1;
        this.StudenteTitle = this.currentStudente ? `${this.currentStudente.nome} ${this.currentStudente.cognome}` : '';
      })
    );
  }

  checkCurrentStudenteAfterRequest(studenti: Studente[]): boolean {
    // ESISTE UNO STUDENTE SELEZIONATO PRESENTE NELLA GET STUDENTI
    return !!this.getCurrentStudente() && !!studenti.find((studente) => studente.id === this.currentStudente?.id)
  }

  checkCurrentStudenteLocalStorage(studenti: Studente[]): Studente | undefined {
    return !!this.getSavedStudenteId()  ? studenti.find((studente) => studente.id === this.getSavedStudenteId()) : undefined
  }


  //GESTIONE FIGLI

  pipeAggiornaStudente$(studente: Studente) {
    return of(studente).pipe(
      tap(() =>
        this.StudenteTitle = (!!this.currentStudente) ? (this.currentStudente?.nome + ' ' + this.currentStudente?.cognome) : ''),
      tap(() => this.getStudenteInfo()),
    )
  }

  getStudenteInfo() {
    const figli = this.opzioniStudenti;
    this.isMultipleChildren = (figli.length > 1);
    this.StudenteTitle = this.currentStudente?.nome + ' ' + this.currentStudente?.cognome;
  }

  private getSavedStudenteId(): string | null {
    try {
      return localStorage.getItem(GlobalManagerFigliService.LS_KEY);
    } catch {
      return null;
    }
  }

  private saveCurrentStudenteId(id: string | undefined) {
    if(id){
      localStorage.setItem(GlobalManagerFigliService.LS_KEY, id);

    }
  }

  removeSavedStudenteId() {
    try {
      localStorage.removeItem(GlobalManagerFigliService.LS_KEY);
    } catch {
    }
  }
}

